<template>

  <div class="flex flex-col w-full bg-blue-200">


    <div class="mt-64 ">
        <button 
        class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
        v-on:click="closeStudioBusinessPage">{{$t('profile.close')}}</button>
    </div>


    <ring-loader v-if="showLoader"></ring-loader>

    <div v-if="businessInfo != null">

         <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">

            <label class="mr-2 lg:mr-5"><strong>{{$t('business.customerBusinessLogo')}} </strong></label>

        <img v-if="businessInfo.logo != ''" :src="businessInfo.logo" class="ml-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="brandImageRef" width="100"/>
        <img v-else src="@/assets/images/full-logo.jpg" class="ml-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="brandImageRef" width="100"/>
        </div>


        <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                        
                <label class="mr-5"><strong>{{$t('business.businessName')}} </strong></label>

                <label
                class="mr-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
                {{businessInfo.name}}</label>
        </div>

        <div class="flex flex-col lg:flex-row justify-center items-center mb-2 lg:mb-10 w-full">
                        
            <label class="lg:mr-5" ><strong>{{$t('business.location')}} </strong></label>

            <div class="border border-gray-300">
            <my-google-maps-view :location="businessInfo.location"></my-google-maps-view>
            </div>
        </div>

        <div class="flex justify-center items-center mb-2 lg:mb-10 w-full">
                        
            <label class="mr-5"><strong>{{$t('profile.phone')}} </strong></label>

            <label
            class="mr-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{businessInfo.phone}}</label>
        </div>

        <div class="flex justify-center items-center mb-2 lg:mb-10 w-full">
                    
            <label class="mr-5"><strong>{{$t('business.country')}} </strong></label>

            <label
            class="mr-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{businessInfo.location.country}}</label>
        </div>

        <div class="flex justify-center items-center mb-2 lg:mb-10 w-full">
                        
            <label class="mr-5"><strong>{{$t('classes.locationName')}}  </strong></label>

            <label
            class="mr-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{businessInfo.location.name}}</label>
        </div>
        

        <div class="flex justify-center items-center mb-2 lg:mb-10 w-full">
                    
            <label class="mr-5"><strong>{{$t('business.address')}} </strong></label>

            <label
            class="mr-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{businessInfo.address}}</label>
        </div>



    </div>
   
  </div>
</template>

<script>

import myGoogleMapsView from '../components/MyGoogleMapsView';

import myQueries from '../hasura/myQueries';

import componentsHelpers from '../classes/componentHelpers';


export default {

    created(){

        // console.log(`business is ${JSON.stringify(this.businessInfo)}`);
    },
  props: {

    // businessInfo: {

    //     type: Object,
    //     default: () => ({}) 
    // },


    closeStudioBusinessPage: {

        type: Function 
    },


    businessId: 0,

    userId: 0,

  },
  components: {

    myGoogleMapsView
  },

  async mounted(){

      // console.log(`businessId: ${this.businessId}`);

    const apollo = this.$apollo;

    const toasted = this.$toasted;

    let userId = this.userId;

    const t = this.$t;
    
    try{

        this.showLoader = true;
        
        let businessResult = await this.$apollo.query({
        query: myQueries.one_business_query,

        variables:{

            businessId: this.businessId
        },

        error(error){
            
            this.showLoader = false;
            componentsHelpers.sendError(apollo, userId, 'StudiosSubscriptionsStudios', 'StudioBusinessPage', 'mounted - catch 1', error);

            componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

        //   this.tokenError = JSON.stringify(error);
        },   
    });

      // console.log(`businessResult: ${JSON.stringify(businessResult)}`);

    if(businessResult.data.business != null){

        if(businessResult.data.business.length > 0){

            this.businessInfo = businessResult.data.business[0];
        }
    }

    this.showLoader = false;

    }catch(error){

        this.showLoader = false;
        componentsHelpers.sendError(apollo, userId, 'StudioSubscriptionsStudios', 'StudioBusinessPage', 'mounted - catch 2', error);

        componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
    }
    
    this.showLoader = false;
},
  methods: {



  },

  computed: {


  },

  data:()=> {

    return {


      showLoader: false,

      businessName: '',

      businessInfo: null

    }
  },

  
}
</script>

<style lang="scss">

label{
  width: 150px;
}


</style>